<template>
  <div class="auth">
    <h3>Авторизация</h3>
    <div v-if="errors.length">
      <div v-for="(error, key) in errors" :key="key" class="auth__alert">
        {{ error }}
      </div>
    </div>
    <div v-if="storeErrors.length">
      <div v-for="(error, key) in storeErrors" :key="key" class="auth__alert">
        {{ error }}
      </div>
    </div>
    <div class="auth__form">
      <div class="auth__formDiv">
        <label>Номер телефона<span class="red">*</span></label>
        <input
          v-model="phone"
          tabindex="1"
          type="text"
          name="phone"
          placeholder="+7 (___) ___-__-__"
          v-mask="{
            mask: '+7 (F##) ###-##-##',
            tokens: {
              F: {
                pattern: /(?!8)\d/,
              },
              '#': { pattern: /\d/ },
            },
          }"
        />
      </div>
      <div class="auth__formDiv">
        <label>Пароль<span class="red">*</span></label>
        <input
          v-model="password"
          tabindex="2"
          name="password"
          :type="showPass ? 'text' : 'password'"
        />
        <img @click="showPass = !showPass" src="@/profile/assets/icons/input-eye.svg" alt="eye">
      </div>
      <div class="auth__details">
        <div class="auth__remember">
          <input v-model="remember" type="checkbox" name="rememberme" />
          <span>Запомнить</span>
        </div>
        <span class="auth__forgot" @click="$router.push({name: 'forgot'})">Забыли пароль?</span>
      </div>
      <div class="auth__btnBlock">
        <button @click="sendAuthData" tabindex="5" class="auth__submit">Войти</button>
        <span class="auth__btnBlock-or">или</span>
        <div class="auth__gosuslugi-btn" @click="gosulugiAuth" tabindex="6">
          <div class="auth__gosuslugi-container">
            <img src="@/profile/assets/icons/gosuslugi.svg" alt="gosuslugi">
            <span class="auth__gosuslugi-text">Войти через Госуслуги</span>
          </div>
        </div>
        <div style="margin-top: 10px;" class="auth__gosuslugi-btn" @click="tbankAuth" tabindex="6">
          <div class="auth__gosuslugi-container">
            <img src="@/profile/assets/icons/t-bank.svg" alt="t-bank">
            <span class="auth__gosuslugi-text">Войти через Т-Банк</span>
          </div>
        </div>
      </div>
      <div class="auth__agreement">
        <p>Нажимая "Войти" я
          <a target="_blank" href="https://makclife.ru/o-kompanii/obrabotka-personalnykh-dannykh.php">соглашаюсь</a>
          на обработку моих персональных данных</p>
      </div>
      <div class="auth__registration">
        <button @click="$router.push({name: 'signin'})">Регистрация</button>
      </div>
      <div class="auth__instruction">
        <a target="_blank" href="https://www.makclife.ru/web/files/lk.pdf">
          Инструкция по работе в личном кабинете*
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";

export default {
  name: "LoginView",
  data() {
    return {
      errors: [],
      phone: null,
      password: null,
      remember: false,
      authType: "PASS",
      showPass: false
    };
  },
  computed: {
    storeErrors() {
      return this.$myApp.errors.value ? this.$myApp.errors.value : [];
    }
  },
  beforeMount() {
    this.$myApp.auth.set(true);
  },
  methods: {
    async sendAuthData() {
      // console.log(`sendAuthData`);
      if (this.validationAuth()) {
        let params = {
          action: "auth",
          object: "cpa",
          phone: this.phone.replace(/\D/g, "").substring(1),
          password: this.password,
          remember: this.remember,
          token: this.$myApp.token.get(),
          auth_type: this.authType
        };

        let api = await this.$api2.get(params);
        if (api.success) {
          if (api.data.menu) {
            this.$myApp.menu.set(api.data.menu);
          }
          if (api.data.roles) {
            this.$myApp.role.set(api.data.roles);
          }
          if (api.data.names) {
            this.$myApp.name.set(
              api.data.names.first_name + " " + api.data.names.last_name
            );
          }
          this.$myApp.auth.set(false);
          this.$router.push({ name: "home" });
        } else if (api.error) {
          if (api.error_code == 8027) {
            this.$myApp.auth.set(true);
            this.$router.push({ name: "changepass" });
          }
          this.errors = [];
          this.errors = api.errors;
          this.password = null;
          this.remember = null;
        }
      }
    },
    async gosulugiAuth() {
      let params = {
        action: "get-esia-link",
        object: "cpa",
        token: this.$myApp.token.get(),
        redirect: "https://" + window.location.host + "/profile"
      };
      let api = await this.$api2.get(params);

      if (api.error) {
        this.errors = [];
        this.errors = api.errors;
      }

      if (api.success) {
        window.open(api.data.url, "_self");
      }
    },
    async tbankAuth() {
      // console.log(this.$myApp.token.get());

      let params = {
        action: "get-tbank-link",
        object: "cpa",
        token: this.$myApp.token.get(),
        redirect: "https://" + window.location.host + "/profile"
      };
      let api = await this.$api2.get(params);

      if (api.success) {
        window.open(api.data.url, "_self");
      }
    },
    validationAuth() {
      this.errors = [];
      if (!this.phone) {
        this.errors.push("Укажите номер телефона.");
      }
      if (!this.password) {
        this.errors.push("Введите пароль");
      }
      if (!this.errors.length) {
        return true;
      } else {
        return false;
      }
    }
  },
  directives: { mask }
};
</script>

<style scoped>
/*.btn-block-red:hover {*/
/*  background-color: #F04868;*/
/*  color: white;*/
/*}*/

/*.btn-block-red {*/
/*  color: #F04868;*/
/*  border: 1px solid #F04868;*/
/*}*/

.authorization-block h3 {
  font-weight: 700;
  font-size: 16pt;
  margin-bottom: 10px;
}
</style>
